import { useContainer } from '../../useContainer';
import { ContactApi, ToastStateHandler } from '../../../api';
import { PatchContactDto } from '../../../commonTypes/client.types';
import { dispatch } from '../../../store';
import { editContact } from '../../../store/slices/clients.slice';
import { useTranslation } from '../../useTranslation';

const useHttpPatchContact = () => {
    const { t } = useTranslation('newNotifications');
    const contactApi: ContactApi = useContainer(ContactApi);
    const toastHandler: ToastStateHandler = useContainer(ToastStateHandler);

    const exec = (clientId: string, body: PatchContactDto) => {
        const { exec, abort } = contactApi.update({
            params: { clientId },
            body,
            onSuccess: _ => {
                dispatch(editContact({ clientId, contact: body }));
                toastHandler.push('success', t('contact.updateContactTitle'), t('contact.updateContactMessage_Success'));
            },
            onError: _ => {
                toastHandler.push('error', t('contact.updateContactTitle'), t('contact.updateContactMessage_Failed'));
            },
        });
        exec();
        return abort;
    };

    return { exec };
};

export default useHttpPatchContact;
